import {Component, Input, OnInit} from '@angular/core';
import {LienItemModel} from '../../models/menu/lien-item.model';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
})
export class NavBarComponent implements OnInit {
  @Input() lienItems: Array<LienItemModel>;

  constructor() {}

  ngOnInit() {}
}
